import axios, { InternalAxiosRequestConfig, AxiosRequestHeaders } from 'axios';

// Utility function to get client validation headers
const getClientValidationHeaders = () => {
  if (typeof window === 'undefined') return {};

  const groupHash = import.meta.env.VITE_APP_GROUP_HASH || document.querySelector('meta[name="x-group-hash"]')?.getAttribute('content');
  let groupHost = new URL(window.location.href).host;

  // For dev environment, use VITE_APP_DOMAIN_DEV if host contains localhost
  if (groupHost.includes('localhost')) {
    groupHost = import.meta.env.VITE_APP_DOMAIN_DEV || groupHost;
  }

  return {
    ...(groupHash && { 'x-group-hash': groupHash }),
    ...(groupHost && { 'x-group-host': groupHost }),
  };
};

export const aiApi = axios.create({
  baseURL: import.meta.env.VITE_AI_API_BASE_URL || 'https://ai-virgil.liambo.ai/',
  headers: {
    'Content-Type': 'application/json',
  },
});

aiApi.interceptors.request.use((config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  // Get client validation headers
  const clientHeaders = getClientValidationHeaders();

  // Add client validation headers to all AI API requests
  config.headers = {
    ...config.headers,
    ...clientHeaders,
  } as AxiosRequestHeaders;

  return config;
});

aiApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle AI API specific errors
    console.error('AI API Error:', error);
    return Promise.reject(error);
  }
);
